import { useEffect } from 'react';

import { modalTypes } from '@/enums';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getBidderId, getIsVipConfirmationEligible } from '@/redux/modules/account/user/user.selectors';
import { openVipConfirmationModal } from '@/redux/modules/modal';
import { getOpenModal } from '@/redux/modules/modal.selectors';
import { useVipConfirmationExperiment } from '@/utils/amplitude/experiments/hooks/useVipConfirmation.experiment';

import { VipConfirmationModal } from './VipConfirmationModal';

const hasSeenVipConfirmation = (vipConfirmationStorageKey: string) =>
    typeof window !== 'undefined' && localStorage.getItem(vipConfirmationStorageKey) === 'true';

const VipConfirmationModalTrigger = () => {
    const dispatch = useAppDispatch();
    const isBackendEligible = useAppSelector(getIsVipConfirmationEligible);
    const bidderId = useAppSelector(getBidderId);
    const isExperimentTreatment = useVipConfirmationExperiment();
    const isVipConfirmationEligible = isBackendEligible || isExperimentTreatment;
    const openModal = useAppSelector(getOpenModal);
    const isVipOpen = openModal === modalTypes.VIP_CONFIRMATION;
    const isModalOpen = openModal !== modalTypes.NONE;
    const vipConfirmationStorageKey = `vipConfirmation-${bidderId}`;
    const shouldOpen = isVipConfirmationEligible && !isModalOpen && !hasSeenVipConfirmation(vipConfirmationStorageKey);

    useEffect(() => {
        if (shouldOpen) {
            localStorage.setItem(vipConfirmationStorageKey, 'true');
            dispatch(openVipConfirmationModal());
        }
    }, [dispatch, shouldOpen, vipConfirmationStorageKey]);

    if (!isVipOpen) {
        return null;
    }

    return <VipConfirmationModal />;
};

export default VipConfirmationModalTrigger;
